import { render } from "./CommRecord.vue?vue&type=template&id=51ba22c4&scoped=true"
import script from "./CommRecord.vue?vue&type=script&lang=js"
export * from "./CommRecord.vue?vue&type=script&lang=js"

import "./CommRecord.vue?vue&type=style&index=0&id=51ba22c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ba22c4"]])

export default __exports__